export const directReporteesHeatmapFetchDataKeyReset = (state, payload) => {
  return {
    ...state,
    isDataFetchedDirectReportee: false
  }

}